import PageHeader from '@/components/common/PageHeader';

const DisclaimerPage = () => {
  return (
    <div data-testid="disclaimer-page">
      <PageHeader 
        title="Disclaimer"
        subtitle="Important information about our services and website content"
        breadcrumbs={[{ label: 'Disclaimer' }]}
      />

      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto prose prose-lg">
            <p className="text-gray-600 mb-8">
              <strong>Last Updated: January 1, 2026</strong>
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">General Disclaimer</h2>
            <p className="text-gray-600 mb-6">
              The information provided on this website (www.zafco.in) is for general informational purposes only. 
              While Zafco Human Resource Management strives to keep the information up to date and accurate, we 
              make no representations or warranties of any kind, express or implied, about the completeness, 
              accuracy, reliability, suitability, or availability of the information contained on this website.
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">Immigration Information</h2>
            <p className="text-gray-600 mb-6">
              Immigration laws, policies, and procedures are subject to frequent changes by government authorities. 
              The information provided on this website may not reflect the most current immigration requirements. 
              We recommend consulting with our experts or relevant government authorities for the latest information.
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">No Legal Advice</h2>
            <p className="text-gray-600 mb-6">
              The content on this website does not constitute legal advice and should not be relied upon as such. 
              For specific legal questions related to immigration, please consult a qualified immigration attorney 
              or the relevant immigration authorities.
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">No Guarantee of Results</h2>
            <p className="text-gray-600 mb-6">
              While we have a high success rate, we cannot guarantee the approval of any visa or immigration 
              application. Success stories and testimonials on this website are individual results and may not 
              be typical. Each case is unique and subject to the assessment of immigration authorities.
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">External Links</h2>
            <p className="text-gray-600 mb-6">
              This website may contain links to external websites. We have no control over the content, privacy 
              policies, or practices of third-party websites and accept no responsibility for them.
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">Processing Times</h2>
            <p className="text-gray-600 mb-6">
              Processing times mentioned on this website are estimates based on current averages and may vary 
              significantly depending on individual circumstances, workload of immigration authorities, and 
              completeness of applications.
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">Fee Information</h2>
            <p className="text-gray-600 mb-6">
              Government fees, third-party charges, and other costs mentioned are subject to change without notice. 
              Please confirm all fees with our team before proceeding with any application.
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">Use at Your Own Risk</h2>
            <p className="text-gray-600 mb-6">
              Any reliance you place on the information on this website is strictly at your own risk. In no event 
              will we be liable for any loss or damage including without limitation, indirect or consequential loss 
              or damage, arising from the use of this website.
            </p>

            <h2 className="text-2xl font-bold text-zafco-blue mb-4">Contact Us</h2>
            <p className="text-gray-600 mb-6">
              If you have any questions about this Disclaimer, please contact us at:
            </p>
            <p className="text-gray-600 mb-6">
              <strong>Zafco Human Resource Management</strong><br />
              Ground Floor 5, Building No. 27B,<br />
              Khizrabad, New Friends Colony,<br />
              New Delhi - 110025<br />
              Phone: +91-9958848998<br />
              Email: info@zafco.in
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DisclaimerPage;
